import { getStudioDetailsAPI } from '~entities/studios/api/get-studio-details';

import {
  buildPostLoginDestination,
  type PostLoginDestination,
} from './studio-login-redirect';

/**
 * Complete post-login bootstrap without calling studios/dashboard/location.
 * That endpoint refreshes GHL tokens and hangs when Studio is not running in GHL.
 * user-login already issued a JWT with studioId; /studios/location uses that.
 */
export const completeStandaloneStudioLogin = async (
  locationId: string,
  redirect?: string | null,
): Promise<PostLoginDestination> => {
  const studio = await getStudioDetailsAPI();
  return buildPostLoginDestination(studio.locationId || locationId, redirect);
};
